export const CARE_ROUNDS_ROUTES = {
  dashboard    : 'panel',
  careRoundForm: 'formulario/detalles/paciente'

};
